import { useIsMobile as useIsMobileHook } from '@urbantxt/styles';

export default useIsMobileHook;
